export const VALID_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const MAX_FILE_SIZE = 5242880;